import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeProjectExternalLink(
    request: Boundaries["removeProjectExternalLink"]["request"],
  ): void;
}

function useRemoveProjectExternalLink(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRemoveProjectExternalLinkRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRemoveProjectExternalLinkRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRemoveProjectExternalLinkRequestFailure,
    ),
    removeProjectExternalLink: core.removeProjectExternalLink,
  };
}

export { useRemoveProjectExternalLink };
